import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CacheService {
  
  private dayMS;
  private expireDate;

  public HOUR = 1000*60*60;
  public SIX_HOURS = 1000*60*60*6;
  public DAY = 1000*60*60*24;

  constructor() { 
    // 1000*60*60 1 Hora
    // 1000*60*60*24 1 Día
    // 1000*60*60*24*7 1 Semana

    this.dayMS = 1000*60*60;
    this.expireDate = Date.now()+this.dayMS;
  }

  isCache(key){    
    return localStorage.getItem(key)!=null;
  }

  saveCache(key,data, expires = this.dayMS){        
    var save = JSON.stringify({"data" : data, "expires" : Date.now()+expires});
    localStorage.setItem(key, save);
  }

  getCache(key){ 
    if (this.isCache(key)){
      return JSON.parse(localStorage.getItem(key)).data;  
    }
    return null;
  }

  isCacheExpired(key){
    if (!this.isCache(key)){      
      return true;
    }
    var expires_in = JSON.parse(localStorage.getItem(key)).expires;    
    return (Date.now() - expires_in) > this.dayMS;

  }

  clearCache(key){
    localStorage.removeItem(key);
  }
}
